import {
  Component,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Subscription, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';
import { SetSearch } from 'src/app/store/actions';
import { hasSearch } from 'src/app/store/selectors';

// TODO: make the search an autocomplete
@Component({
  selector: 'app-cropfield-search',
  templateUrl: './cropfield-search.component.html',
  styleUrls: ['./cropfield-search.component.scss'],
  standalone: false,
})
export class CropFieldSearchComponent<T> implements OnInit, OnDestroy, OnChanges {
  private readonly store = inject<Store<SiteState>>(Store);

  @Input() values: T[] = [];
  @Input() keys: (keyof T)[] = [];
  @Output() filtered = new EventEmitter<T[]>();
  @ViewChild('search', { static: false }) searchElement: ElementRef;
  searchControl = new FormControl();
  search$ = this.store.pipe(select(hasSearch));
  private subscription: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['values']) {
      this.searchControl.enable({ emitEvent: true });
    }
  }

  ngOnInit() {
    this.subscription = combineLatest([this.searchControl.valueChanges, this.search$])
      .pipe(
        map(([query, search]: [string, boolean]) => {
          if (!!query !== search) {
            this.store.dispatch(new SetSearch(!!query));
          }
          return query.toLowerCase();
        }),
        startWith(''),
        map((query) =>
          query
            ? this.values.filter((value) =>
                this.keys.length > 0
                  ? this.keys
                      .map((key) => value[key].toString().toLowerCase().indexOf(query) !== -1)
                      .filter(Boolean).length > 0
                  : JSON.stringify(value).toLowerCase().indexOf(query) !== -1,
              )
            : this.values,
        ),
      )
      .subscribe(this.filtered);

    this.subscription.add(
      this.search$.subscribe((search) => {
        if (!search) {
          this.searchControl.setValue('');
        }
      }),
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
